//
//
//
//

export default {
  name: 'SkillName',
  props: {
    skill: {
      type: Object,
      required: true
    }
  },
  computed: {
    name () {
      const skills = this.$store.getters['util/getAllSkillsMappings']
      return skills[this.skill.id]?.name
    }
  }
}
